import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDepMandatory1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#4A5666",
		strokeWidth: 1.5,
		transform: "translate(-3 -3)",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 4,
			fill: "#4A5666"
		}), /* @__PURE__ */ _jsx("path", {
			strokeLinecap: "square",
			d: "m11.5 11.5 7.071 7.071"
		})]
	})
});
export default SvgDepMandatory1;
